import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconMic, IconMicSlash } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { setVolume, setVolumeDisabled } from '../../../filmstrip/actions.web';
const useStyles = makeStyles()(() => {
    return {
        muteUserButton: {
            padding: '3px !important',
            borderRadius: '4px',
            '& svg': {
                width: '18px',
                height: '18px'
            }
        }
    };
});
const SingleMuteButton = ({ participantId }) => {
    const dispatch = useDispatch();
    const localParticipantId = useSelector((state) => state['features/base/participants'].local?.id);
    const volume = useSelector((state) => state['features/filmstrip'].participantsVolume?.[participantId] ?? 1);
    const cachedVolume = useSelector((state) => state['features/filmstrip'].participantsVolumeCache?.[participantId] ?? 1);
    const isMuted = volume === 0;
    if (participantId === localParticipantId) {
        return null;
    }
    const onClick = (event) => {
        event.stopPropagation();
        const newVolume = isMuted ? cachedVolume : 0;
        dispatch(setVolume(participantId, newVolume));
        dispatch(setVolumeDisabled(participantId, newVolume === 0));
    };
    return (React.createElement(Button, { accessibilityLabel: isMuted ? 'Stummschalten aufheben' : 'Stummschalten', className: useStyles().classes.muteUserButton, icon: isMuted ? IconMicSlash : IconMic, 
        // eslint-disable-next-line react/jsx-no-bind
        onClick: onClick, size: 'small' }));
};
export default SingleMuteButton;
